import * as React from 'react';
import styled from 'styled-components';
import { ProductInterface } from '@westwing/appshell_types';
import { ProductImage } from '@westwing/ui-kit/Product';
import { MediaImage } from '@ids/components/Media/MediaImage';

const StyledProductImage = styled(ProductImage)`
    place-content: center;
    padding: 10px;
`;

export interface ProductPictureProps {
    product: ProductInterface;
    'data-testid'?: string;
}

const ProductPicture = (props: ProductPictureProps) => {
    const { product, 'data-testid': testId } = props;
    const { baseImage, altTag } = product;

    return (
        <StyledProductImage>
            <MediaImage
                src={baseImage}
                alt={altTag}
                data-testid={testId}
                quality={60}
                sizes="(max-width: 767px) 50vw, (min-width: 767px) 25vw, 155px"
            />
        </StyledProductImage>
    );
};

export default ProductPicture;
